import dynamic from 'next/dynamic';
import { DynamicDCAComponentProvider } from '@marriott/mi-headless-utils';
import { MerchandisingLayeredFeatureProps } from './organisms/MerchandisingLayeredFeature/MerchandisingLayeredFeature.types';

const SkeletonLoaderStyles = dynamic(() => import('./skeleton-loader.styles').then(mod => mod.SkeletonLoaderStyles));

const HeroBanner = dynamic(() =>
  import('./organisms/MerchandisingHeroBanner').then(mod => mod.MerchandisingHeroBanner)
);
const SmallBanner = dynamic(() =>
  import('./organisms/MerchandisingSmallBanner').then(mod => mod.MerchandisingSmallBanner)
);
const SmallBannerNonEditable = dynamic(() =>
  import('./organisms/MerchandisingSmallBanner').then(mod => mod.MerchandisingSmallBannerComponent)
);
const TileSkinny = dynamic(() =>
  import('./organisms/MerchandisingTileSkinny').then(mod => mod.MerchandisingTileSkinny)
);
const TileSkinnyNonEditable = dynamic(() =>
  import('./organisms/MerchandisingTileSkinny').then(mod => mod.MerchandisingTileSkinnyComponent)
);
const DCADecision = dynamic(() => import('./organisms/DCADecisionContainer').then(mod => mod.DCADecisionContainer));
const CardTile = dynamic(() => import('./organisms/MerchandisingCardTile').then(mod => mod.MerchandisingCardTile));
const CardTileNonEditable = dynamic(() =>
  import('./organisms/MerchandisingCardTile').then(mod => mod.MerchandisingCardTileComponent)
);
const BrandBanner = dynamic(() =>
  import('./organisms/MerchandisingBrandBanner').then(mod => mod.MerchandisingBrandBanner)
);
const BrandBannerNonEditable = dynamic(() =>
  import('./organisms/MerchandisingBrandBanner').then(mod => mod.MerchandisingBrandBannerComponent)
);
const RiottMedia = dynamic(() => import('./organisms/RiottMediaCard').then(mod => mod.RiottMediaCard));
const RiottMediaNonEditable = dynamic(() => import('./organisms/RiottMediaCard').then(mod => mod.RiottMediaComponent));
const PortalModal = dynamic(() => import('./organisms/MerchandisingModal').then(mod => mod.MerchandisingModal));
const PortalModalNonEditable = dynamic(() =>
  import('./organisms/MerchandisingModal').then(mod => mod.MerchandisingModalComponent)
);
const SignInModal = dynamic(() =>
  import('./organisms/MerchandisingSignInModal').then(mod => mod.MerchandisingSignInModal)
);
const SignInModalNonEditable = dynamic(() =>
  import('./organisms/MerchandisingSignInModal').then(mod => mod.MerchandisingSignInModalComponent)
);
const PartnerCard = dynamic(() =>
  import('./organisms/MerchandisingPartnerCard').then(mod => mod.MerchandisingPartnerCard)
);
const PartnerCardNonEditable = dynamic(() =>
  import('./organisms/MerchandisingPartnerCard').then(mod => mod.MerchandisingPartnerCardComponent)
);

const HeroCarouselCard = dynamic(() =>
  import('./organisms/MerchandisingHeroCarouselCard').then(mod => mod.MerchandisingHeroCarouselCard)
);
const HeroCarouselCardNonEditable = dynamic(() =>
  import('./organisms/MerchandisingHeroCarouselCard').then(mod => mod.MerchandisingHeroCarouselCardComponent)
);
const MerchandisingLayeredFeatureComponentNonEditable = dynamic(() =>
  import('./organisms/MerchandisingLayeredFeature/MerchandisingLayeredFeature').then(
    mod => mod.MerchandisingLayeredFeatureComponent
  )
);
const MerchandisingCoBrandCardComponentNonEditable = dynamic(() =>
  import('./organisms/MerchandisingCoBrandCard').then(mod => mod.MerchandisingCoBrandCardComponent)
);

const EyebrowBanner = dynamic(() =>
  import('./organisms/MerchandisingEyebrowBanner').then(mod => mod.MerchandisingEyebrowBanner)
);

export const MerchandisingEyebrowBannerNonEditable = dynamic(() =>
  import('./organisms/MerchandisingEyebrowBanner').then(mod => mod.MerchandisingEyebrowBannerComponent)
);

export const MerchandisingCoBrandCard = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={MerchandisingCoBrandCardComponentNonEditable} props={props} />;
};

export const MerchandisingHeroBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={HeroBanner} props={props} />;
};

export const MerchandisingSmallBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SmallBanner} props={props} />;
};

export const MerchandisingSmallBannerComp = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SmallBannerNonEditable} props={props} />;
};

export const MerchandisingTileSkinny = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={TileSkinny} props={props} />;
};

export const MerchandisingTileSkinnyNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={TileSkinnyNonEditable} props={props} />;
};

export const MerchandisingCardTile = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={CardTile} props={props} />;
};

export const MerchandisingCardTileNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={CardTileNonEditable} props={props} />;
};

export const MerchandisingBrandBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={BrandBanner} props={props} />;
};

export const MerchandisingBrandBannerNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={BrandBannerNonEditable} props={props} />;
};

export const RiottMediaCard = (props: unknown) => {
  return (
    <SkeletonLoaderStyles>
      <DynamicDCAComponentProvider Component={RiottMedia} props={props} />
    </SkeletonLoaderStyles>
  );
};

export const RiottMediaCardNonEditable = (props: unknown) => {
  return (
    <SkeletonLoaderStyles>
      <DynamicDCAComponentProvider Component={RiottMediaNonEditable} props={props} />
    </SkeletonLoaderStyles>
  );
};

export const MerchandisingModalComp = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={PortalModal} props={props} />;
};

export const DCADecisionContainer = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={DCADecision} props={props} />;
};

export const MerchandisingModalNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={PortalModalNonEditable} props={props} />;
};
export const MerchandisingSignInModalComp = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SignInModal} props={props} />;
};

export const MerchandisingSignInModalNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SignInModalNonEditable} props={props} />;
};

export const MerchandisingCarouselContainer = dynamic(() =>
  import('./organisms/MerchandisingCarouselContainer').then(mod => mod.MerchandisingCarouselContainer)
);
export const MerchandisingCarouselContainerNonEditable = dynamic(() =>
  import('./organisms/MerchandisingCarouselContainer').then(mod => mod.MerchandisingCarouselContainerNonEditable)
);

export const MerchandisingDCAContainer = dynamic(() =>
  import('./organisms/MerchandisingDCAContainer').then(mod => mod.MerchandisingDCAContainer)
);
export const MerchandisingPartnerCard = (props: unknown) => {
  return (
    <SkeletonLoaderStyles>
      <DynamicDCAComponentProvider Component={PartnerCard} props={props} />
    </SkeletonLoaderStyles>
  );
};

export const MerchandisingPartnerCardNonEditable = (props: unknown) => {
  return (
    <SkeletonLoaderStyles>
      <DynamicDCAComponentProvider Component={PartnerCardNonEditable} props={props} />
    </SkeletonLoaderStyles>
  );
};

export const MerchandisingHeroCarouselCardNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={HeroCarouselCardNonEditable} props={props} />;
};

export const MerchandisingHeroCarouselCard = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={HeroCarouselCard} props={props} />;
};

export const MerchandisingLayeredFeature = (props: MerchandisingLayeredFeatureProps) => {
  return <DynamicDCAComponentProvider Component={MerchandisingLayeredFeatureComponentNonEditable} props={props} />;
};

export const MerchandisingEyebrowBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={EyebrowBanner} props={props} />;
};
